// extracted by mini-css-extract-plugin
module.exports = {"clockWrapper":"TestClock_clockWrapper__qwq3x","timeDisplay":"TestClock_timeDisplay__Bvl0v","timeDisplayNearEnd":"TestClock_timeDisplayNearEnd__gzBCR"};